module.exports = __webpack_public_path__ + "img/logo.b61e77c2.svg";